module.exports = __webpack_public_path__ + "img/0Q3B3332_T_FoamcoreMatted.e9681f04.jpg";